import React, { memo } from 'react';
import { FileTextIcon, ClockIcon, BarChartIcon, ShoppingCartIcon, ShieldCheckIcon, MailIcon } from 'lucide-react';
export const Features = () => {
  return <section className="py-12 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-158">
      <div className="max-w-7xl mx-auto" data-id="element-159">
        <div className="text-center mb-10" data-id="element-160">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-161">
            ¿Qué incluye el Recetario Fit?
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-162">
            Todo lo que necesitas para transformar tu cocina y tu alimentación
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-163">
          <div className="bg-gray-50 p-6 rounded-lg shadow-md" data-id="element-164">
            <div className="bg-teal-100 w-12 h-12 rounded-full flex items-center justify-center mb-4 mx-auto" data-id="element-165">
              <FileTextIcon className="h-6 w-6 text-teal-600" data-id="element-166" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2 text-center" data-id="element-167">
              +60 recetas
            </h3>
            <p className="text-gray-700 text-center" data-id="element-168">
              Desayunos, almuerzos, cenas y snacks. Todas probadas y aprobadas.
            </p>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg shadow-md" data-id="element-169">
            <div className="bg-teal-100 w-12 h-12 rounded-full flex items-center justify-center mb-4 mx-auto" data-id="element-170">
              <ClockIcon className="h-6 w-6 text-teal-600" data-id="element-171" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2 text-center" data-id="element-172">
              Plan de 4 semanas
            </h3>
            <p className="text-gray-700 text-center" data-id="element-173">
              Organización semanal para que nunca más te preguntes "¿qué
              comemos?"
            </p>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg shadow-md" data-id="element-174">
            <div className="bg-teal-100 w-12 h-12 rounded-full flex items-center justify-center mb-4 mx-auto" data-id="element-175">
              <BarChartIcon className="h-6 w-6 text-teal-600" data-id="element-176" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2 text-center" data-id="element-177">
              Macros por porción
            </h3>
            <p className="text-gray-700 text-center" data-id="element-178">
              Control total de calorías, proteínas, grasas y carbohidratos.
            </p>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg shadow-md" data-id="element-179">
            <div className="bg-teal-100 w-12 h-12 rounded-full flex items-center justify-center mb-4 mx-auto" data-id="element-180">
              <ShoppingCartIcon className="h-6 w-6 text-teal-600" data-id="element-181" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2 text-center" data-id="element-182">
              Listas imprimibles
            </h3>
            <p className="text-gray-700 text-center" data-id="element-183">
              Listas de compras organizadas para ahorrar tiempo y dinero.
            </p>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg shadow-md" data-id="element-184">
            <div className="bg-teal-100 w-12 h-12 rounded-full flex items-center justify-center mb-4 mx-auto" data-id="element-185">
              <ShieldCheckIcon className="h-6 w-6 text-teal-600" data-id="element-186" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2 text-center" data-id="element-187">
              Garantía 7 días
            </h3>
            <p className="text-gray-700 text-center" data-id="element-188">
              "Sin vueltas" - Si no te sirve, te devolvemos tu dinero.
            </p>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg shadow-md" data-id="element-189">
            <div className="bg-teal-100 w-12 h-12 rounded-full flex items-center justify-center mb-4 mx-auto" data-id="element-190">
              <MailIcon className="h-6 w-6 text-teal-600" data-id="element-191" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2 text-center" data-id="element-192">
              Entrega inmediata
            </h3>
            <p className="text-gray-700 text-center" data-id="element-193">
              Recibí todo por mail apenas completás tu compra.
            </p>
          </div>
        </div>
        <div className="mt-10 text-center" data-id="element-194">
          <a href="https://vhwt09-gz.myshopify.com/checkouts/cn/hWN3ajyOi9gyqJJTJgcXUW4g/es-ar?cart_link_id=CISumiVv&preview_theme_id=133233049643" className="inline-block bg-teal-600 hover:bg-teal-700 text-white font-bold py-3 px-8 rounded-lg shadow-lg hover:shadow-xl transition duration-300 text-xl w-full sm:w-auto" data-id="element-195">
            Quiero todo hoy solo por $19.990
          </a>
          <p className="mt-4 text-sm text-gray-600" data-id="element-196">
            Probalo 7 días. Si no te sirve, devolución 100%.
          </p>
        </div>
      </div>
    </section>;
};